import { Dialog } from "@finanedi.es/storybook"
import { getFacturaPdfById } from "api/Factura.service"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import { APP_STYLE_SETTINGS_FINANWAY } from "common/context/constants"
import notification from "common/utils/notification"
import fileDownload from "js-file-download"
import { useTranslation } from "react-i18next"
import {
  FormatoDocumento,
  getFormato,
  getNameFile,
  ModalTypeDownloadDocumentProps,
} from "./constant"

const ModalTypeDownloadDocument = ({
  modalState,
  onHide,
  showElements,
  typeDocument,
}: ModalTypeDownloadDocumentProps) => {
  const { t } = useTranslation()

  const notificationError = () => {
    notification.errorServidor({
      body: `${t("errorMsg.downloadDocument")}`,
    })
  }

  const notificationSuccess = () => {
    notification.success({ body: `${t("successMsg.downloadDocument")}` })
  }

  const downloadFacturaMap = (id: string) => ({
    PDF: () => getFacturaPdfById(id),
    // todo: Activate when the XML download is available
    // XML: () => getFacturaEdi(id, DOC_TYPE_FORMAT.FACTURA_E),
  })

  const handleDownload = async (formato: FormatoDocumento) => {
    if (!modalState.id) return

    try {
      const formatoFn = downloadFacturaMap(modalState.id)[formato]

      if (!formatoFn) return

      const { data } = await formatoFn()

      fileDownload(
        new Blob([data]),
        `${getNameFile(TIPO_DOCUMENTO_ENUM.FACTURA)}${
          modalState.serie ? `_${modalState.serie}` : ""
        }.${getFormato(formato).toLocaleLowerCase()}`
      )

      notificationSuccess()
    } catch (error) {
      notificationError()
    }
  }

  return (
    <Dialog
      visible={modalState.show}
      className='tw-rounded-lg tw-bg-white !tw-w-auto'
      baseZIndex={20}
      closable
      keepInViewport={false}
      headerClassName='[&>:first-child]:!tw-text-lg'
      header={`${t("crear.presupuesto.modal.downloadArchivo")} ${getNameFile(
        typeDocument
      )}`}
      footer={false}
      onHide={onHide}
    >
      <div className='tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-mt-3'>
        {showElements.downloadPdf && (
          <div
            className='tw-flex tw-flex-col tw-w-60 tw-items-center tw-gap-2 tw-cursor-pointer'
            onClick={() => handleDownload("PDF")}
          >
            <img
              src={APP_STYLE_SETTINGS_FINANWAY.pdf}
              alt='document-icon'
              className='tw-w-12'
            />
            <span className='tw-font-medium'>
              {t("crear.presupuesto.modal.pdf")}
            </span>
            <p className='tw-text-center tw-text-sm tw-text-wrap tw-h-auto tw-w-60'>
              {t("crear.presupuesto.modal.msg.pdfMsg")}
            </p>
          </div>
        )}
        {/*  
        // todo: Activate when the XML download is available
       {showElements.downloadXml && (
          <div
            className='tw-flex tw-flex-col tw-w-60 tw-items-center tw-gap-2 tw-cursor-pointer'
            onClick={() => handleDownload("XML")}
          >
            <img
              src={APP_STYLE_SETTINGS_FINANWAY.xml}
              alt='document-icon'
              className='tw-w-12'
            />
            <span className='tw-font-medium'>
              {t("crear.presupuesto.modal.facuraE")}
            </span>
            <p className='tw-text-center tw-text-sm tw-text-wrap tw-h-auto tw-w-60'>
              {t("crear.presupuesto.modal.facturaEMsg")}
            </p>
          </div>
        )} */}
      </div>
    </Dialog>
  )
}

export default ModalTypeDownloadDocument
